import {Observable} from "rxjs";
import {Pbx} from "../models/pbx";
import {UnitCallEventsFilters} from "../../units/models/unit-call-events-filters";
import {CallEvent} from "../../units/models/call-event";
import {PbxMode} from "../models/pbx_mode";
import {BaseApiService} from "../../shared/utils/base-api-service";

export abstract class PbxManager extends BaseApiService {

    abstract getPbxs(): Observable<Pbx[]>;
    abstract getPbxDashboard(installation_id: string, pbx_id: string): Observable<Pbx>;
    abstract getPbxCallEvents(
        installation_id: string,
        pbx_id: string,
        pagination?: any,
        filters?: UnitCallEventsFilters
    ): Observable<CallEvent[]>;
    abstract changePbxMode(installation_id: string, pbx_id: string, mode: PbxMode): Observable<Pbx>;

}
